module.exports = __webpack_public_path__ + "static/media/cup_top_2.0925ef76.png";